import { render, staticRenderFns } from "./PageFieldsImport.vue?vue&type=template&id=df489ed2&scoped=true&"
import script from "./PageFieldsImport.vue?vue&type=script&lang=js&"
export * from "./PageFieldsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df489ed2",
  null
  
)

export default component.exports